
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/make-payment",
      function () {
        return require("private-next-pages/make-payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/make-payment"])
      });
    }
  